export default __webpack_public_path__ + "static/media/investors-other.e266e229.mp3";